var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5586 12.4737C23.5586 6.12241 18.4099 0.973688 12.0586 0.973688C5.70731 0.973688 0.558594 6.12241 0.558594 12.4737C0.558594 18.2137 4.76398 22.9713 10.2617 23.834V15.7979H7.3418V12.4737H10.2617V9.94009C10.2617 7.05791 11.9786 5.46588 14.6054 5.46588C15.8636 5.46588 17.1797 5.69049 17.1797 5.69049V8.52056H15.7296C14.301 8.52056 13.8555 9.40703 13.8555 10.3165V12.4737H17.0449L16.5351 15.7979H13.8555V23.834C19.3532 22.9713 23.5586 18.2137 23.5586 12.4737Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e803c93b6c1c645ee8f2f817efe14ace.svg";
export { ForwardRef as ReactComponent };